import { ConversationMessageTypeEnum } from '@/enums/crm/conversation-message-type.enum';

export default class ConversationMessageTypeModel {
  id!: number;

  code!: ConversationMessageTypeEnum;

  name!: string;
}
